import { ReactElement, useEffect, useState } from "react";
import React from "react";
import { formatDate } from "../../../assets/dateHelper";
import { Movie } from "../../../models/movie";
import { useParams } from "react-router-dom";
import { getMovies } from "../../../data/movies";

import "./filmOutlet.scss";
import { useTranslation } from "react-i18next";

async function isAuthorizedToViewMovie(currentMovie: Movie): Promise<boolean> {
  if (!currentMovie.requiresAuth) return true;

  const res = await fetch('/api/check-auth');
  const data = await res.json();
  const { authorized } = data;
  return authorized;
}

function FilmOutlet(args: { currentMovie?: Movie }): ReactElement {
  const { t } = useTranslation();

  let currentMovie: Movie = args.currentMovie;
  const { movieName } = useParams();
  if (!currentMovie) {
    currentMovie = getMovies().find(movie => movie.id.toLowerCase() === movieName.toLowerCase());
  }

  const [authSuccessful, setAuthSuccessful] = useState(false);
  useEffect(() => {
    isAuthorizedToViewMovie((currentMovie)).then(result => {
      setAuthSuccessful(result);
      if (!result) {
        window.open('/movies', '_self');
      }
    });
  });

  return (
    <div className={'flex-grow-1 theme-' + currentMovie.id}>
      <div hidden={authSuccessful}>
        <div className="d-flex justify-content-center align-items-center mt-5 pt-5">
          <div className="loader"></div>
        </div>
      </div>
      <div hidden={!authSuccessful}>
        <div className="w-100 d-flex justify-content-center">
          <iframe
            className="w-100"
            src={currentMovie.links.movie}
            title={currentMovie.name}
            allow="clipboard-write;
                          encrypted-media;
                          gyroscope;
                          picture-in-picture;
                          web-share"
            style={{maxWidth: "2000px"}}
            allowFullScreen></iframe>
        </div>
        <div>
          <div hidden={!currentMovie.citations} className="app-body">
            <div className="container py-3">
              {[0, 1, 2].map(index => (
                <div className={index % 2 === 0 ? 'row' : 'row justify-content-end text-end'}
                     key={'citation-' + index}>
                  <h2 className="h2 py-3">{t("movies." + currentMovie.id + ".citation_" + (index + 1) + ".author")}
                    <span
                      className="fw-lighter ms-1">{t("movies." + currentMovie.id + ".citation_" + (index + 1) + ".role")}</span>
                  </h2>
                  <div className="col-xxl-7 col-xl-9 col-lg-12">
                    <p className="w-100">
                      “{t("movies." + currentMovie.id + ".citation_" + (index + 1) + ".body")}”
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="app-body bg-different py-5">
            <div className="container">
              <div className="row">
                <div className="col-12 col-sm-4 text-center py-3">
                  <i className="bi bi-journal-text d-block"
                     style={{ fontSize: '5rem' }}></i>
                  <h4>{t("movies.dates.plan")}</h4>
                  <p>{formatDate(currentMovie.dates.planningStart) + " - " + formatDate(currentMovie.dates.planningEnd)}</p>
                </div>
                <div className="col-12 col-sm-4 text-center py-3">
                  <i className="bi bi-camera-reels d-block"
                     style={{ fontSize: '5rem' }}></i>
                  <h4>{t("movies.dates.shoot")}</h4>
                  <p>{formatDate(currentMovie.dates.shootingStart) + " - " + formatDate(currentMovie.dates.shootingEnd)}</p>
                </div>
                <div id={"making-of-" + currentMovie.id} className="col-12 col-sm-4 text-center py-3">
                  <i className="bi bi-film d-block"
                     style={{ fontSize: '5rem' }}></i>
                  <h4>{t("movies.dates.publish")}</h4>
                  <p>{formatDate(currentMovie.dates.published)}</p>
                </div>
              </div>
            </div>
          </div>

          <button className="btn position-fixed bottom-0 start-50 translate-middle-x my-5 px-4 rounded-pill border-3 border-white bg-opacity-75" onClick={() => window.location.href = "#making-of-" + currentMovie.id}>
            <div className="d-flex flex-row align-items-center">
              <i className="bi bi-arrow-down fs-3"></i>
              <h4 className="p-0 m-0 text-nowrap">{t("Making Of")}</h4>
            </div>
          </button>

          <div className="app-body py-5">
            <div className="container">
              <div className="row">
                <div className="col-12 col-md-6">
                  <h2 className="text-center">{t("movies.extras.making_of")}</h2>
                  <iframe
                    className="w-100 my-3 rounded-3"
                    src={currentMovie.links.makingOf}
                    title={currentMovie.name + "_Making Of"}
                    allow="clipboard-write;
                                encrypted-media;
                                gyroscope;
                                picture-in-picture;
                                web-share"
                    allowFullScreen></iframe>
                </div>
                <div className="col-12 col-md-6">
                  <h2 className="text-center">{t("movies.extras.trailer")}</h2>
                  <iframe
                    className="w-100 my-3 rounded-3"
                    src={currentMovie.links.trailer}
                    title={currentMovie.name + "_Trailer"}
                    allow="clipboard-write;
                                encrypted-media;
                                gyroscope;
                                picture-in-picture;
                                web-share"
                    allowFullScreen></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FilmOutlet;